/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.LinkPreview = function( txt, fxStyle) {
    var config = expocadfx.config;
    var Dialog = expocadfx.Dialog;
    var data = expocadfx.fxData;
    var elemById = expocadfx.element.elementById;
    var body = document.getElementsByTagName( "body")[0];
    var dialog = null;

    var obj = {
        title: txt.LINK_PREVIEW,
        headerBackgroudColor: fxStyle.windowHeader.clrBg !== "" ? 
            fxStyle.windowHeader.clrBg : fxStyle.mainHeader.clrBg,
        headerTextColor: fxStyle.windowHeader.clrText !== "" ? 
            fxStyle.windowHeader.clrText : fxStyle.mainHeader.clrText,
        cancelLabel: txt.CLOSE,
        width: 400,
        height: 160,
        posX: data.viewportWidth / 2 - 150,
        posY: data.viewportHeight / 2 - 100,
        rightButton: { id:"pl_open", label:txt.OPEN_EMAIL},
        leftButtons: [
            { id:"previewLink", label:txt.LINK_PREVIEW }
        ],
        draggable: false
    };
            
    if( fxStyle.windowHeader.gradBg !== "") {
        obj.headerBackground = fxStyle.windowHeader.gradBg;
    }
    else {
        if( fxStyle.windowHeader.clrBg === "" && fxStyle.mainHeader.gradBg !== "") {
            obj.headerBackground = fxStyle.mainHeader.gradBg;
        }
    }
    //   window size change, orientation change ????
    
    dialog = new Dialog( obj, body, elemById("mask"));
            
    elemById( "previewLink").addEventListener( "click", function() {
        window.open( dialog.content.textContent);
    });

    elemById( "pl_open").addEventListener( "click", function() {
        var subject = encodeURIComponent( (config.eventTitle !== "") ? config.eventTitle:" ");
        var bod = encodeURIComponent( dialog.content.textContent);
		
        window.location.href = "mailto:" + " " + "?subject=" + subject + "&body=" + bod;
    });
    
    return dialog;
};